import React, { useCallback } from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react"
import {
  Button,
  Dropdown,
  Flex,
  Input,
  Select,
  Typography,
  DatePicker,
  Checkbox,
  Radio,
} from "antd"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import {
  clubsAction,
  getDecodedApiKey,
} from "src/store/Slices/Administrator/ClubsSlice"
import { MaskedInput } from "antd-mask-input"
import { any, element } from "prop-types"
import { getClubTypes } from "src/store/Slices/DropDownSlice"
import "./style.css"
import { openNotification } from "src/components/helpers/notification"
import ReactInputMask from "react-input-mask"
import dayjs from "dayjs"

const AddEditClubModal = ({
  visible,
  setVisible,
  clubInfo,
  setPage,
  setPageSize,
  clubId,
  mnemo,
}) => {
  const items = [
    {
      key: "1",
      label: <strong>Вы уверены?</strong>,
    },
    {
      key: "2",
      label: (
        <Button
          type={"dashed"}
          onClick={() => {
            dispatch(getDecodedApiKey({ value: apiKey }))
            setIsEditeble(true)
          }}
        >
          Да
        </Button>
      ),
    },
  ]

  const dispatch = useDispatch()

  const clubTypes = useSelector((state) => state.DropDownSlice.clubTypes)

  const [name, setName] = useState()
  const [address, setAddress] = useState()
  const [phone, setPhone] = useState()
  const [contacts, setContacts] = useState([])
  const [type, setType] = useState()
  const [workHours, setWorkHours] = useState()
  const [coor, setCoor] = useState()
  const [dateOpen, setDateOpen] = useState()
  const [apiKey, setApiKey] = useState()
  const [publicId, setPublicId] = useState()
  const [isEditeble, setIsEditeble] = useState(false)
  const [selectedContactIndex, setSelectedContactIndex] = useState(-1)
  const [popupTitle, setPopupTitle] = useState("")
  const [popupDescription, setPopupDescription] = useState("")

  useEffect(() => {
    setName()
    setAddress()
    setPhone()
    setContacts([])
    setType()
    setWorkHours()
    setCoor()
    setDateOpen()
    setApiKey()
    setPublicId()
    setIsEditeble(false)
    setSelectedContactIndex(-1)
  }, [visible.flag])

  useEffect(() => {
    if (visible.flag === "edit" || visible.flag === "contacts") {
      setName(clubInfo?.name)
      setAddress(clubInfo?.address)
      setPhone(clubInfo?.phone)
      const formattedContacts =
        clubInfo?.contacts?.map((contact) => ({
          phone: contact.phone,
          isWhatsApp: contact.isWhatsApp || false,
          tid: contact.tid,
        })) || []
      setContacts(formattedContacts)
      setType(
        clubTypes?.data?.value?.find((el) => el.label === clubInfo?.type)
          ?.value,
      )
      setWorkHours(clubInfo?.workHours)
      setCoor(clubInfo?.coordinates)
      setDateOpen(clubInfo?.dateOpen)
      setApiKey(clubInfo?.apiKey)
      setPublicId(clubInfo?.publicId)

      const whatsAppIndex = formattedContacts.findIndex(
        (contact) => contact.isWhatsApp === true,
      )
      setSelectedContactIndex(whatsAppIndex)
    }
  }, [visible, clubInfo, clubTypes])

  const onClickSubmit = () => {
    let flag = true
    contacts.forEach((contact) => {
      if (contact.phone.includes("_") || contact.phone === "") {
        openNotification({
          type: "error",
          message:
            "Проверьте правильность введённых номеров. Все номера должны быть заполнены полностью",
        })
        flag = false
      }
    })

    const contactsToSend = contacts.map((contact, index) => ({
      phone: contact.phone,
      isWhatsApp: selectedContactIndex === index,
      ...(contact.tid && { tid: contact.tid }),
    }))

    if (flag) {
      dispatch(
        clubsAction(
          isEditeble
            ? {
                flag: visible.flag === "add" ? "put" : "post",
                value: {
                  id: visible.flag !== "add" ? clubId : null,
                  name: name,
                  address: address,
                  phone: phone,
                  contacts: contactsToSend,
                  typeId: type,
                  workHours: workHours,
                  coordinates: coor,
                  dateOpen: dateOpen,
                  publicId: publicId,
                  apiKey: apiKey,
                  doorOpenTitle: popupTitle,
                  doorOpenText: popupDescription,
                },
              }
            : {
                flag: visible.flag === "add" ? "put" : "post",
                value: {
                  id: visible.flag !== "add" ? clubId : null,
                  name: name,
                  address: address,
                  phone: phone,
                  contacts: contactsToSend,
                  typeId: type,
                  workHours: workHours,
                  coordinates: coor,
                  dateOpen: dateOpen,
                  publicId: publicId,
                  doorOpenTitle: popupTitle,
                  doorOpenText: popupDescription,
                },
              },
        ),
      ).then(() => {
        dispatch(clubsAction({ flag: "get" })).then(() => {
          setVisible({ open: false, flag: "" })
          setPage(1)
          setPageSize(20)
        })
      })
    }
  }

  const handleAddContact = () => {
    setContacts([
      ...contacts,
      {
        phone: "",
        isWhatsApp: false,
      },
    ])
  }

  const handleDeleteContact = (index) => {
    const newContacts = contacts.filter((_, ind) => index !== ind)

    if (selectedContactIndex === index) {
      setSelectedContactIndex(-1)
    } else if (selectedContactIndex > index) {
      setSelectedContactIndex(selectedContactIndex - 1)
    }

    setContacts(newContacts)
  }

  const changeHandler = useCallback(
    (value, index) => {
      let newContacts = [...contacts]
      newContacts[index] = {
        ...newContacts[index],
        phone: value,
      }
      setContacts(newContacts)
    },
    [contacts],
  )

  const handleContactSelect = (index) => {
    setSelectedContactIndex(index)
  }

  useEffect(() => {
    if (visible.flag === "edit") {
      dispatch(getClubTypes())
    }
  }, [visible])

  return (
    <CModal
      alignment='center'
      visible={visible.open}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible({ open: false, flag: "" })
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {visible.flag === "add"
            ? "Добавить клуб"
            : visible.flag === "contacts"
              ? "Контакты"
              : "Редактировать клуб"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            {visible.flag === "contacts" ? (
              contacts?.length > 0 ? (
                contacts?.map((contact, index) => (
                  <div key={index}>
                    <Typography.Title level={5}>
                      {contact.phone}
                      {contact.isWhatsApp && " (WhatsApp)"}
                    </Typography.Title>
                  </div>
                ))
              ) : (
                <Typography.Title level={5}>
                  Нет дополнительных контактов
                </Typography.Title>
              )
            ) : (
              <>
                <div>
                  <Typography.Title level={5}>
                    Заголовок попапа
                  </Typography.Title>
                  <Input
                    value={popupTitle}
                    onChange={(e) => setPopupTitle(e.currentTarget.value)}
                  />

                  <Typography.Title level={5}>Текст попапа</Typography.Title>
                  <Input
                    value={popupDescription}
                    onChange={(e) => setPopupDescription(e.currentTarget.value)}
                  />

                  <Typography.Title level={5}>Public Id</Typography.Title>
                  <Input
                    value={publicId}
                    onChange={(e) => setPublicId(e.currentTarget.value)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Наименование</Typography.Title>
                  <Input
                    value={name}
                    onChange={(e) => setName(e.currentTarget.value)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Адрес</Typography.Title>
                  <Input
                    value={address}
                    onChange={(e) => setAddress(e.currentTarget.value)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Номер телефона</Typography.Title>
                  <MaskedInput
                    className='custom-input'
                    mask='+{0} (000) 000-00-00'
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value)
                    }}
                  />
                </div>
                <div className='contacts-div'>
                  {contacts?.length > 0 && (
                    <Typography.Title level={5}>
                      Дополнительные номера телефонов
                      <br />
                      <small>
                        Выберите только один номер для социальной сети
                      </small>
                    </Typography.Title>
                  )}
                  {contacts?.map((contact, index) => (
                    <div key={index} className='add-contacts-div'>
                      <ReactInputMask
                        className='custom-input'
                        value={contact.phone}
                        mask={"+7 (999) 999-99-99"}
                        onChange={(e) => {
                          changeHandler(e.target.value, index)
                        }}
                      />
                      <Radio
                        className='custom-radio'
                        checked={selectedContactIndex === index}
                        onChange={() => handleContactSelect(index)}
                      />
                      <CButton
                        onClick={() => handleDeleteContact(index)}
                        className='text-light'
                        disabled={
                          !mnemo?.children.find(
                            (ele) => ele.mnemo === "deleteBtn",
                          )
                        }
                      >
                        Удалить
                      </CButton>
                    </div>
                  ))}
                  <CButton
                    onClick={handleAddContact}
                    className='text-light'
                    disabled={
                      !mnemo?.children.find((ele) => ele.mnemo === "insertBtn")
                    }
                  >
                    Добавить номер
                  </CButton>
                </div>
                <div>
                  <Typography.Title level={5}>Тип клуба</Typography.Title>
                  <Select
                    style={{ width: "100%" }}
                    placeholder='Выбрать'
                    onClick={() => {
                      visible.flag === "add" && dispatch(getClubTypes())
                    }}
                    value={type}
                    onChange={(e) => {
                      setType(e)
                    }}
                    options={clubTypes?.data?.value}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Часы работы</Typography.Title>
                  <Input
                    value={workHours}
                    onChange={(e) => setWorkHours(e.currentTarget.value)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Координаты</Typography.Title>
                  <Input
                    value={coor}
                    onChange={(e) => setCoor(e.currentTarget.value)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Дата открытия клуба
                  </Typography.Title>
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"YYYY-MM-DD"}
                    placement={"topRight"}
                    onChange={(date) => {
                      setDateOpen(date ? date.format("YYYY-MM-DD") : null)
                    }}
                    value={dateOpen ? dayjs(dateOpen) : null}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Ключ</Typography.Title>
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      transition: "all 1s ease",
                    }}
                  >
                    <Input
                      value={apiKey}
                      onChange={(e) => setApiKey(e.currentTarget.value)}
                      type={isEditeble ? "text" : "password"}
                      disabled={!isEditeble}
                    />
                    {!isEditeble && (
                      <Button
                        onClick={() => {
                          if (!apiKey || apiKey.trim() === "") {
                            setIsEditeble(true)
                            return
                          }
                          dispatch(getDecodedApiKey({ value: apiKey })).then(
                            () => {
                              setIsEditeble(true)
                            },
                          )
                        }}
                      >
                        Редактировать
                      </Button>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        </Flex>
      </CModalBody>
      {visible.flag !== "contacts" && (
        <CModalFooter>
          <CButton
            onClick={() => {
              setVisible({ open: false, flag: "" })
            }}
            className='text-light'
            color='secondary'
          >
            Закрыть
          </CButton>
          <CButton onClick={onClickSubmit} className='text-light'>
            {visible.flag === "add" ? "Добавить" : "Редактировать"}
          </CButton>
        </CModalFooter>
      )}
    </CModal>
  )
}

export default AddEditClubModal
